<template>
  <div
    class="flex cursor-pointer"
    :class="{ 'w-full': checkboxText }"
    @click="toggle"
  >
    <span :class="checkboxIconClass">
      <tick-icon
        v-if="value"
        :class="`fill-current ${checkboxTickClass || 'h-4 w-4'}`"
      ></tick-icon>
    </span>
    <span
      v-if="checkboxText"
      :class="`${checkboxTextClass || 'ml-2 text-white'}`"
      >{{ checkboxText }}</span
    >
  </div>
</template>

<script>
import TickIcon from '@fortawesome/fontawesome-free/svgs/solid/check.svg';

export default {
  name: 'GdCheckbox',
  components: {
    TickIcon,
  },
  props: {
    value: { required: true },
    isDisabled: { default: false },
    checkboxClass: {},
    checkboxText: {},
    checkboxTextClass: {},
    checkboxTickClass: {},
    checkboxIconBgClass: {},
  },
  computed: {
    checkboxIconClass() {
      let classes =
        this.checkboxClass || 'flex-none h-6 w-6 flex items-center justify-center rounded-lg text-white border border-solid border-grey-200';
      if (this.isDisabled) {
        classes += ' bg-grey-200';
      } else if (this.checkboxIconBgClass && this.value) {
        classes += ` ${this.checkboxIconBgClass}`;
      } else if (this.value) {
        classes += ' bg-grey-800';
      } else {
        classes += ' bg-white';
      }

      return classes;
    },
  },
  methods: {
    toggle() {
      if (!this.isDisabled) {
        this.$emit('input', !this.value);
        this.$emit('change', !this.value);
      }
    },
  },
};
</script>
